// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3c28F","wrapper":"styles_wrapper__tEFdT"};